import { 
	GET_PROJECT_TWR_CATEGORIES, 
	GET_PROJECT_TWR_CATEGORY,
	CREATE_PROJECT_TWR_CATEGORY,
	UPDATE_PROJECT_TWR_CATEGORY,
	DESTROY_PROJECT_TWR_CATEGORY,
} from "./actions"

export function ProjectTwrCategoriesReducer(state = {}, action) {
	switch (action.type) {
		case `${GET_PROJECT_TWR_CATEGORIES}_FULFILLED`:{
			return _.mapKeys(action.payload.data, "id");
		}
		case `${GET_PROJECT_TWR_CATEGORY}_FULFILLED`:
		case `${CREATE_PROJECT_TWR_CATEGORY}_FULFILLED`:
		case `${UPDATE_PROJECT_TWR_CATEGORY}_FULFILLED`:{
			let newState = _.clone(state);
			const newItem = action.payload.data;
			const id = _.get(newItem,"id")
			newState[id] = newItem
			return newState;
		}		
		case `${DESTROY_PROJECT_TWR_CATEGORY}_FULFILLED`:{
			let newState = _.clone(state);
			const deletedItem = action.payload.data;
			const id = _.get(deletedItem,"id")
			newState = _.filter(newState,i => i.id != id)
			return newState;
		}
		default:
			return state;
	}
}

// Move this to the reducer page
// import { ProjectTwrCategoriesReducer } from "modules/project/twr/categories/reducer"

// project_twr_categories:ProjectTwrCategoriesReducer,
